import React, { useState } from "react";
import "./styles.css";

const FourthQuestionFormComponent = ({
  questions,
  onChangeQuestions,
  sendData,
  setShowErrorModal,
}) => {
  const [error, setError] = useState(false);
  const onClickRadio = (event) => {
    const id = event.target.id;
    let observations = "";
    let question;

    if (id === "optionYes1") {
      question = "q6";
      saveDataQuestion(id, observations, question);
    } else if (id === "optionNo1") {
      question = "q6";
      saveDataQuestion(id, "", question);
    }

    if (id === "optionYes2") {
      question = "q7";
      saveDataQuestion(id, observations, question);
    } else if (id === "optionNo2") {
      question = "q7";
      saveDataQuestion(id, "", question, false);
    }
  };

  const onClickCheckBox = (event) => {
    const id = event.target.id;
    const checked = event.target.checked;
    let question = "";

    if (id === "checkBox") {
      setError(false);
      question = "q7";
      saveDataQuestion(id, "", question, checked);
    }
  };

  const saveDataQuestion = (id, observations, question, checked) => {
    let valueQuestion;
    if (id === "optionYes1" || (id === "checkBox" && checked)) {
      valueQuestion = true;
    } else {
      valueQuestion = false;
    }
    const updatedQuestions = {
      ...questions,
      [question]: { response: valueQuestion, observations: observations },
    };
    onChangeQuestions(updatedQuestions, question);
  };

  const onClickNext = () => {
    if (questions.q6.response !== "" && questions.q7.response === true) {
      sendData();
    } else {
      if (questions.q7.response !== true) {
        setError(true);
      }
      setShowErrorModal(true);
    }
  };

  return (
    <div className="fourthQuestionForm">
      <h1 className="titleConsent">
        INFORMACIÓN Y CONSENTIMIENTO DE USO DE LA APP WHATSAPP COMO VÍA DE
        COMUNICACIÓN
      </h1>
      <p className="textConsent">
        En orden a efectuar una correcta y ágil comunicación con usted, por
        medio del presente documento solicitamos su consentimiento para utilizar
        la aplicación informática Whatsapp como medio de contacto.
      </p>
      <label className="labelConsentCheckbox">
        Autorizo la utilización de la aplicación Whatsapp como medio de
        contacto.
      </label>
      <div className="radioInputContainer">
        <label>
          <input
            type="radio"
            id="optionYes1"
            name="question1"
            onChange={(event) => onClickRadio(event)}
          />
          Si
        </label>
        <label>
          <input
            type="radio"
            id="optionNo1"
            name="question1"
            onChange={(event) => onClickRadio(event)}
          />
          No
        </label>
      </div>
      <p className="textConsent">
        Siguiendo los principios de licitud, lealtad y transparencia, ponemos a
        su disposición la presente tabla informándole del tratamiento de los
        datos personales que se dispone a proporcionarnos:
      </p>
      <table className="tableConsent">
        <tbody>
          <tr className="titleTableConsent">
            <td className="tdTableConsent" colSpan="2">
              INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS
            </td>
          </tr>
          <tr>
            <td className="tdTableConsent">Responsable</td>
            <td className="tdTableConsent">
              ALEJANDRIA CENTRO MÉDICO Y DOCENTE, S.L.
            </td>
          </tr>
          <tr>
            <td className="tdTableConsent">Finalidad principal</td>
            <td className="tdTableConsent">
              Gestionar la relación comercial/profesional.
            </td>
          </tr>
          <tr>
            <td className="tdTableConsent">Legitimación</td>
            <td className="tdTableConsent">
              Gestionar la relación comercial/profesional.
            </td>
          </tr>
          <tr>
            <td className="tdTableConsent">Destinatarios</td>
            <td className="tdTableConsent">
              No se cederán datos a terceros, salvo autorización expresa u
              obligación legal.
            </td>
          </tr>
          <tr>
            <td className="tdTableConsent">Derechos</td>
            <td className="tdTableConsent">
              Acceder, rectificar y suprimir los datos, portabilidad de los
              datos, litación u posición a su tratamiento, transparencia y
              derecho a no ser objeto de decisiones a utomatizadas.
            </td>
          </tr>
          <tr>
            <td className="tdTableConsent">Información adicional</td>
            <td className="tdTableConsent">
              Puedo consultar la información adicionaly detallada sobre nuestra{" "}
              <a
                className="aTableConsent"
                href="https://clinicaalejandria.es/politica-de-privacidad"
                target="_blank"
              >
                Política de Privacidad.
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <label className="labelConsentCheckbox">
        <div
          className="checkboxContainer"
          style={{
            backgroundColor: error === true ? "red" : "#fcfbfa",
          }}
        >
          <input
            type="checkbox"
            id="checkBox"
            onClick={(event) => onClickCheckBox(event)}
            className="inputCheckbox"
          />
        </div>
        Declaro haber entendido la información facilitada y consiento el
        tratamiento que se efectuará de mis datos de carácter personal,
        incluyendo datos de salud
      </label>
      <button className="btnForm" onClick={onClickNext}>
        Enviar
      </button>
    </div>
  );
};

export default FourthQuestionFormComponent;
